import axios from 'axios'
import { baseUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 查询角色信息
export function getRoles(params) {
  const url = baseUrl + '/role/features/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '查询角色信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询菜单列表
export function getMenu(params) {
  const url = baseUrl + '/feature/tree'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '查询菜单列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 新增角色
export function saveRole(params) {
  const url = baseUrl + '/role/save'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '新增角色', res)
    }
    return Promise.resolve(res.data)
  })
}

// 编辑角色
export function editRole(params) {
  const url = baseUrl + '/role/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '编辑角色', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除角色
export function delRole(params) {
  const url = baseUrl + '/role/softdelete/' + params.id
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '删除角色', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取当前用户菜单权限
export function getFeature(params) {
  const url = baseUrl + '/feature/login'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('角色管理', '获取当前用户菜单权限', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取当前角色用户数量
export function getRoleUserNum(params) {
  const url = baseUrl + '/role/user/count'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('综合视图', '获取当前角色用户数量', res)
    }
    return Promise.resolve(res.data)
  })
}
